import { render, staticRenderFns } from "./Switcher.vue?vue&type=template&id=ab441a50&scoped=true"
import script from "./Switcher.vue?vue&type=script&lang=ts"
export * from "./Switcher.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab441a50",
  null
  
)

export default component.exports